import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

import { CategoriesTable } from 'components/CategoriesTable';
import { CATEGORY_TYPE_ITEMS } from 'constants/other';

export function Categories() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <TablePageLayout
      title="Категории"
      actionContent={
        <Button
          sx={{ ml: 5 }}
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            tableRef.current?.openFormDialog();
          }}
        >
          Добавить категорию
        </Button>
      }
    >
      <CategoriesTable
        id="categories-table"
        ref={tableRef}
        editPageUrl="/categories"
        automaticallyOpenEditPage
        searchFilter={{
          inputProps: {
            placeholder: 'Поиск по названию',
          },
          filter: (search) => ({
            _or: search.flatMap((str) => [{ name: { _ilike: `%${str}%` } }]),
          }),
        }}
        customFilter={{
          filters: [
            {
              name: 'Тип',
              field: 'type',
              type: 'select',
              items: CATEGORY_TYPE_ITEMS,
            },
          ],
        }}
      />
    </TablePageLayout>
  );
}
